import paths from 'routing/routes/_paths';
import Beacon from 'views/beacon';
import PostForm from 'views/beacon/posts/form';

const beacon = [
  {
    path: [`${paths.beacon}`, `${paths.beacon}/posts`],
    component: Beacon,
    app: true,
    type: 'private',
    exact: true,
    documentTitle: (_, { location }) =>
      `Beacon.Help Signals | ${location.pathname.includes('posts') ? 'Posts' : 'Menu'}`
  },
  {
    path: `${paths.beacon}/posts/create`,
    component: PostForm,
    app: true,
    type: 'private',
    exact: true,
    documentTitle: 'Beacon.Help Signals | Create Post'
  },
  {
    path: `${paths.beacon}/posts/:id`,
    component: PostForm,
    app: true,
    type: 'private',
    exact: true,
    documentTitle: 'Beacon.Help Signals | Edit Post'
  }
];

export default beacon;
